// Mock data for frontend functionality

// ============ IMAGES ============
export const images = {
  hero: 'https://images.unsplash.com/photo-1706036957257-1be06faf7486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzd2ltbWluZyUyMHBvb2wlMjBsdXh1cnklMjBpbmRvb3J8ZW58MHx8fHwxNzc2MTc1NDkwfDA&ixlib=rb-4.1.0&q=85',
  poolIndoor: 'https://images.unsplash.com/photo-1770967307107-446055488c0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxzd2ltbWluZyUyMHBvb2wlMjBsdXh1cnklMjBpbmRvb3J8ZW58MHx8fHwxNzc2MTc1NDkwfDA&ixlib=rb-4.1.0&q=85',
  poolLounge: 'https://images.unsplash.com/photo-1770033138625-cb1dac7f1c47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxzd2ltbWluZyUyMHBvb2wlMjBsdXh1cnklMjBpbmRvb3J8ZW58MHx8fHwxNzc2MTc1NDkwfDA&ixlib=rb-4.1.0&q=85',
  kidsTraining: 'https://images.unsplash.com/photo-1706842137129-1fdf63bb9bb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxraWRzJTIwc3dpbW1pbmclMjB0cmFpbmluZyUyMGNvYWNoaW5nJTIwcG9vbHxlbnwwfHx8fDE3NzYxNzU0OTF8MA&ixlib=rb-4.1.0&q=85',
  toddlerPool: 'https://images.unsplash.com/photo-1557469778-0b3269a1cc7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxraWRzJTIwc3dpbW1pbmclMjB0cmFpbmluZyUyMGNvYWNoaW5nJTIwcG9vbHxlbnwwfHx8fDE3NzYxNzU0OTF8MA&ixlib=rb-4.1.0&q=85',
  poolTraining: 'https://images.unsplash.com/photo-1639477651629-3afd5d79654d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxraWRzJTIwc3dpbW1pbmclMjB0cmFpbmluZyUyMGNvYWNoaW5nJTIwcG9vbHxlbnwwfHx8fDE3NzYxNzU0OTF8MA&ixlib=rb-4.1.0&q=85',
  familyPool: 'https://images.unsplash.com/photo-1769989110678-376aa8faaf25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxzd2ltbWluZyUyMHBvb2wlMjBmYW1pbHklMjBzdW1tZXJ8ZW58MHx8fHwxNzc2MTc1NDkyfDA&ixlib=rb-4.1.0&q=85',
  jacuzzi: 'https://images.unsplash.com/photo-1772040942277-b194d9d0b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxqYWN1enppJTIwc3BhJTIwd2VsbG5lc3MlMjB3YXRlciUyMHRoZXJhcHl8ZW58MHx8fHwxNzc2MTc1NDkyfDA&ixlib=rb-4.1.0&q=85',
  babySwim: 'https://images.unsplash.com/photo-1594802891000-821590ef3313?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxpbmZhbnQlMjBiYWJ5JTIwc3dpbW1pbmclMjBwb29sfGVufDB8fHx8MTc3NjE3NTQ5M3ww&ixlib=rb-4.1.0&q=85',
  babyFloat: 'https://images.unsplash.com/photo-1624887479363-f513b4cd9c7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxpbmZhbnQlMjBiYWJ5JTIwc3dpbW1pbmclMjBwb29sfGVufDB8fHx8MTc3NjE3NTQ5M3ww&ixlib=rb-4.1.0&q=85',
  poolUmbrella: 'https://images.unsplash.com/photo-1770306924721-eda564e356b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxqYWN1enppJTIwc3BhJTIwd2VsbG5lc3MlMjB3YXRlciUyMHRoZXJhcHl8ZW58MHx8fHwxNzc2MTc1NDkyfDA&ixlib=rb-4.1.0&q=85',
};

// ============ SELF SWIMMING MEMBERSHIPS ============
export const individualPlans = [
  {
    id: 'ind-1m',
    duration: '1 Month',
    price: 6000,
    validity: '30 Days',
    note: '1 hour per day',
  },
  {
    id: 'ind-3m',
    duration: '3 Months',
    price: 15000,
    validity: '90 Days',
    note: '1 hour per day',
  },
  {
    id: 'ind-6m',
    duration: '6 Months',
    price: 25000,
    validity: '180 Days',
    note: '1 hour per day',
    popular: true,
  },
  {
    id: 'ind-12m',
    duration: '12 Months',
    price: 40000,
    validity: '360 Days',
    note: '1 hour per day',
  },
];

export const familyPlans = [
  {
    id: 'fam-1m',
    duration: '1 Month',
    price: 10000,
    validity: '30 Days',
    note: '1 hour per day per member',
  },
  {
    id: 'fam-3m',
    duration: '3 Months',
    price: 25000,
    validity: '90 Days',
    note: '1 hour per day per member',
  },
  {
    id: 'fam-6m',
    duration: '6 Months',
    price: 40000,
    validity: '180 Days',
    note: '1 hour per day per member',
    popular: true,
  },
  {
    id: 'fam-12m',
    duration: '12 Months',
    price: 65000,
    validity: '360 Days',
    note: '1 hour per day per member',
  },
];

export const flexibleRecharge = [
  {
    id: 'flex-10',
    hours: '10 Hours',
    price: 3500,
    validity: '30 Days',
    note: '1 Member - Sharing Allowed',
  },
  {
    id: 'flex-50',
    hours: '50 Hours',
    price: 15000,
    validity: '90 Days',
    note: '1 Member - Sharing Allowed',
    popular: true,
  },
  {
    id: 'flex-100',
    hours: '100 Hours',
    price: 25000,
    validity: '180 Days',
    note: '1 Member - Sharing Allowed',
  },
];

// ============ SWIMMING TRAINING PROGRAMS ============
export const batchTraining = [
  { id: 'bt-16', sessions: '16 Sessions', price: 6999, validity: '1 Month', members: '1 Member' },
  { id: 'bt-32', sessions: '32 Sessions', price: 12999, validity: '2 Months', members: '1 Member' },
  { id: 'bt-60', sessions: '60 Sessions', price: 20000, validity: '3 Months', members: 'Up to 2 Members (Sharing)', popular: true },
  { id: 'bt-75', sessions: '75 Sessions', price: 23000, validity: '5 Months', members: 'Up to 3 Members (Sharing)' },
  { id: 'bt-100', sessions: '100 Sessions', price: 28000, validity: '6 Months', members: 'Up to 4 Members (Sharing)' },
];

export const summerCamp = [
  { id: 'sc-15', sessions: '15 Sessions', price: 6999, validity: '20 Days', members: '1 Member' },
];

export const weekendTraining = [
  { id: 'wt-16', sessions: '16 Sessions', price: 8999, validity: '3 Months', members: '1 Member' },
  { id: 'wt-32', sessions: '32 Sessions', price: 15999, validity: '6 Months', members: '1 Member' },
];

export const infantSwimming = [
  { id: 'is-14', sessions: '14 Sessions', price: 15000, validity: '3 Months', members: '1 Infant' },
  { id: 'is-30', sessions: '30 Sessions', price: 28000, validity: '6 Months', members: '1 Infant' },
];

export const personalTraining = [
  { id: 'pt-10', sessions: '10 Sessions', price: 12000, validity: '1 Month', members: '1 Member' },
  { id: 'pt-20', sessions: '20 Sessions', price: 22000, validity: '1 Month', members: '1 Member' },
];

// ============ DAY PASS SERVICES ============
export const dayPassServices = [
  {
    id: 'general',
    name: 'General Swimming Pool',
    price: 300,
    duration: '1 hour',
    description: 'Access to our non-chlorine, salt-ionized pool for recreational swimming and lap training.',
    features: ['Non-Chlorine Pool', 'Temperature Controlled', 'Lane Swimming', 'Open Swimming'],
  },
  {
    id: 'endurance',
    name: 'Endurance Training',
    price: 999,
    duration: '1 hour',
    description: 'Intensive training with our counter-current water system for enhanced performance.',
    features: ['Counter-Current System', 'Resistance Training', 'Performance Monitoring', 'Equipment Included'],
  },
  {
    id: 'jacuzzi',
    name: 'Jacuzzi',
    price: 500,
    duration: '45 minutes',
    description: 'Relaxation and recovery in our premium jacuzzi facilities.',
    features: ['Heated Jacuzzi', 'Hydrotherapy Jets', 'Relaxation Area', 'Towels Provided'],
  },
  {
    id: 'therapy',
    name: 'Water Therapy',
    price: 999,
    duration: '45 minutes',
    description: 'Therapeutic water sessions for rehabilitation and wellness.',
    features: ['Certified Therapist', 'Personalized Program', 'Medical Equipment', 'Progress Tracking'],
  },
];

// ============ WHY CHOOSE HURUPU POOL ============
export const whyChoose = [
  {
    id: 'non-chlorine',
    title: "Bangalore's Only Non-Chlorine Pool",
    description: 'Hurupu Pool stands out as the only swimming pool in Bangalore that operates without chlorine. A more natural, skin-friendly, and irritation-free swimming experience for all age groups.',
    icon: 'droplet',
  },
  {
    id: 'salt-ionization',
    title: 'Advanced Salt Ionization Technology',
    description: 'We use cutting-edge salt ionization technology to purify water effectively. Crystal-clear water while being gentle on the skin, eyes, and hair.',
    icon: 'zap',
  },
  {
    id: 'uv-filtration',
    title: 'UV Water Filtration System',
    description: 'Our UV filtration system adds an extra layer of protection by eliminating harmful bacteria and pathogens, ensuring the highest level of water purity and safety.',
    icon: 'shield',
  },
  {
    id: 'glass-tile',
    title: 'Premium Glass Tile Finish',
    description: 'Designed with high-quality glass tiles, enhancing both aesthetics and hygiene. Resists algae buildup and maintains a pristine look at all times.',
    icon: 'sparkles',
  },
  {
    id: 'safety',
    title: 'Top-Notch Safety Standards',
    description: 'From pool design to daily operations, we follow strict safety protocols to ensure a secure environment for every swimmer.',
    icon: 'heart',
  },
  {
    id: 'hygiene',
    title: 'Unmatched Hygiene & Maintenance',
    description: 'Rigorous cleaning and maintenance routines, ensuring that the pool water and surroundings remain hygienic, fresh, and safe every single day.',
    icon: 'check-circle',
  },
];

// ============ BOOKINGS (mock) ============
export const mockBookings = [
  {
    id: '1',
    service: 'general',
    date: '2024-01-15',
    time: '10:00 AM',
    name: 'John Doe',
    phone: '+1 234 567 8900',
  },
  {
    id: '2',
    service: 'endurance',
    date: '2024-01-16',
    time: '2:00 PM',
    name: 'Jane Smith',
    phone: '+1 234 567 8901',
  },
];

// ============ CONTACT INFO ============
export const mockContactInfo = {
  address: 'BTM 4th stg, Royal Residency Layout, Hulimavu, Bengaluru, Karnataka 560076',
  email: 'geniexmedia@gmail.com',
  phone: '+91 9900018105',
  support: '+91 9900018105',
  hours: {
    weekdays: '6:00 AM - 10:00 PM',
    weekends: '7:00 AM - 9:00 PM',
  },
};

// ============ COACHES ============
export const coaches = [
  {
    name: 'Santosh',
    specialization: 'Olympic Swimming Coach',
    experience: '12+ years',
    certifications: ['USA Swimming Certified', 'Water Safety Instructor'],
    avatar: 'SA',
  },
  {
    name: 'Jai Surya',
    specialization: 'Fitness & Endurance Trainer',
    experience: '8+ years',
    certifications: ['NASM Certified', 'Aquatic Fitness Specialist'],
    avatar: 'JS',
  },
  {
    name: 'Aadarsh',
    specialization: 'Rehabilitation Specialist',
    experience: '10+ years',
    certifications: ['Physical Therapist', 'Aquatic Therapy Certified'],
    avatar: 'AD',
  },
];
